(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-index"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('e-shop-scroll')) {
    customElements.define('e-shop-scroll', class extends HTMLElement {
      connectedCallback() {
        const more = this.querySelector('.e-shop__more[data-next-url]');
        if (!more) return;
        const eLine = this.querySelector('#e-line');
        const eLineLink = this.querySelector('.e-shop__index a[href="#e-line"]');
        let loadPromise;

        const loadRemaining = () => {
          if (!more.isConnected) return Promise.resolve();
          if (loadPromise) return loadPromise;
          loadPromise = (async () => {
            try {
              const url = new URL(more.dataset.nextUrl, location.origin);
              url.searchParams.set('section_id', this.dataset.sectionId);
              const response = await fetch(url);
              if (!response.ok) throw new Error('Unable to load Circle pieces');
              const html = new DOMParser().parseFromString(await response.text(), 'text/html');
              const incoming = html.querySelector('[data-circle-grid]');
              const current = this.querySelector('[data-circle-grid]');
              if (!incoming || !current || !incoming.children.length) throw new Error('No additional Circle pieces');
              const keepELine = location.hash === '#e-line' && Math.abs(eLine.getBoundingClientRect().top) < 180;
              current.append(...Array.from(incoming.children));
              more.remove();
              if (keepELine) eLine.scrollIntoView({ behavior: 'instant' });
            } catch (error) {
              more.querySelector('a').hidden = false;
              throw error;
            }
          })();
          return loadPromise;
        };

        const observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          observer.disconnect();
          loadRemaining().catch(() => {});
        }, { rootMargin: '700px 0px' });
        observer.observe(more);
        more.querySelector('a').hidden = true;

        eLineLink?.addEventListener('click', async event => {
          if (!more.isConnected) return;
          event.preventDefault();
          observer.disconnect();
          try { await loadRemaining(); } catch (_) {}
          history.pushState(null, '', '#e-line');
          eLine.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
